import Text from '../../Text'
import { TABLE_EMPTY_TEXT } from '../Table.constants'

import * as styles from './TableCellEmpty.module.css'

export function TableCellEmpty({ ref, ...props }) {
  const {
    className = styles.TableCellEmpty,
    value = TABLE_EMPTY_TEXT,
    ...textProps
  } = props

  return (
    <Text {...textProps} className={className} ref={ref}>
      {value}
    </Text>
  )
}

export default TableCellEmpty
